import type { Node } from 'react'
import React, { Component, Fragment } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import type { ECommerceMetadata, EventMetadata } from 'shared/store/metadata'

type Props = {
    url?: string,
    params?: { [string]: any },
    external?: boolean,
    children?: Node,
    meta?: Array<EventMetadata> | EventMetadata,
    eCommerceMeta?: ECommerceMetadata,
    onClick?: (?Event) => void,
    push: string => void,
    sendMeta: EventMetadata => void,
    sendECommerceMeta: ECommerceMetadata => void
}

class LinkComponent extends Component<Props> {
    handleClick = (e: Event) => {
        const {
            external,
            url = '',
            meta,
            eCommerceMeta,
            push,
            sendMeta,
            sendECommerceMeta,
            onClick
        } = this.props
        if (meta) {
            if (!external) {
                push(url)
            }
            if (Array.isArray(meta)) {
                meta.forEach(m => sendMeta(m))
            } else {
                sendMeta(meta)
            }
        }
        if (eCommerceMeta) {
            sendECommerceMeta(eCommerceMeta)
        }
        if (onClick) {
            onClick(e)
        }
    }

    render() {
        const {
            url = '',
            params,
            external = false,
            children,
            meta,
            eCommerceMeta,
            push,
            onClick,
            sendMeta,
            sendECommerceMeta,
            ...otherProps
        } = this.props

        if (!url) {
            return <Fragment>{children}</Fragment>
        }

        return external ? (
            <a
                href={url}
                target="_blank"
                onClick={this.handleClick}
                {...otherProps}>
                {children}
            </a>
        ) : (
            <RouterLink
                to={{ pathname: url, state: params }}
                onClick={this.handleClick}
                {...otherProps}>
                {children}
            </RouterLink>
        )
    }
}

export { LinkComponent }
